<template>

    <div id="app">
        <el-header class="app_header">
            <el-row>
                <el-col :xs="24" :sm="24" :md="20" :lg="20" :xl="24">
                    <div class="grid-content bg-purple-dark">
                        <el-dropdown   @command="handleCommand">
  <span class="el-dropdown-link">
   {{this.$store.state.username}}<i class="el-icon-arrow-down el-icon--right"></i>
  </span>
                            <el-dropdown-menu slot="dropdown" class="downinfolist">
                                <el-dropdown-item command="login" v-show="!this.$store.state.loginstate">登录</el-dropdown-item>
                                <el-dropdown-item command="register" v-show="!this.$store.state.loginstate">注册</el-dropdown-item>
                                <el-dropdown-item command="appindex" v-show="this.$store.state.loginstate">应用首页</el-dropdown-item>
                                <el-dropdown-item command="appuserhome" v-show="this.$store.state.loginstate">个人中心</el-dropdown-item>

                                <el-dropdown-item command="loginout" divided v-show="this.$store.state.loginstate">退出登录</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                       <ul class="app_nav">
                           <li :class="currentclassindex">
                               <a @click="golink('index')">首页</a>
                           </li>
                           <li :class="currentclassplugin">
                               <a @click="golink('plugin')">插件</a>
                           </li>
                           <li :class="currentclasstemplate">
                               <a @click="golink('template')">模板</a>
                           </li>
                           <li :class="currentclassextend">
                               <a @click="golink('extend')">扩展</a>
                           </li>
                           <li :class="currentclasschengxu">
                               <a @click="golink('chengxu')">程序</a>
                           </li>
                       </ul>

                    </div>
                </el-col>
                <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="hidden-sm-and-down">
                    <div class="grid-content bg-purple-dark">
                        <img src="./assets/logor.png" @click="goindex">
                    </div>
                </el-col>
            </el-row>
        </el-header>
        <el-container :class="getcontailer">

            <el-tooltip class="item hidden-sm-and-down" effect="dark" content="上传自己的作品到应用商店" placement="top-start" >
                <el-button @click="uploadapp" v-popover:popover1 class="app_upload_btn" type="danger" icon="el-icon-upload" circle></el-button>
            </el-tooltip>
            <router-view/>
        </el-container>
        <login-form></login-form>

    </div>
</template>

<script>
    import LoginForm from '@/components/Login'

    export default
    {
        name: 'App',
                data()
        {
            return {
                currentclassindex:'',
                currentclassplugin:'',
                currentclasstemplate:'',
                currentclassextend:'',
                currentclasschengxu:'',
                mycontainer: 'container',

            }
        },
        components:{

            'login-form':LoginForm
        },
        created:function(){
            var expiretime=window.localStorage.getItem('expiretime')
            var timestamp = Date.parse(new Date())
             if(expiretime&&expiretime>timestamp){
                 if(window.localStorage.getItem('accesstoken')){
                     this.$store.state.accesstoken=window.localStorage.getItem('accesstoken')
                     this.$store.state.username=window.localStorage.getItem('username')
                     this.$store.state.loginstate=window.localStorage.getItem('loginstate')
                     this.$store.state.uid=window.localStorage.getItem('uid')
                     this.$store.state.currenttype=window.localStorage.getItem('navtitle')
                     this.$store.state.loginstate =true
                 }
             }else{
                 window.localStorage.clear()
             }

            this.getnav()
        },

        mounted:function(){

        },
        computed
        :
            {
                getcontailer:function () {
                    var userAgentInfo = navigator.userAgent;

                    var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
                    var _class=this.mycontainer
                    for (var v = 0; v < Agents.length; v++) {
                        if (userAgentInfo.indexOf(Agents[v]) > 0) {
                            _class=''
                            break;
                        }


                    }
                    return _class
                }
            },
        methods:{
            getnav(){
                var typename=this.$store.state.currenttype
                this.currentclassplugin=""
                this.currentclasstemplate=""
                this.currentclassextend=""
                this.currentclassindex=""
                this.currentclasschengxu=""
                switch(typename){
                    case 'plugin':
                        this.currentclassplugin="current"
                        break;
                    case 'template':
                        this.currentclasstemplate="current"
                        break;
                    case 'extend':
                        this.currentclassextend="current"
                        break;
                    case 'chengxu':
                        this.currentclasschengxu="current"
                        break;
                    default:
                        this.currentclassindex="current"
                        break;
                }
            },
            goindex(){
                this.$router.push({name:'Index',params:{}})
            },
            handleCommand(command) {
                switch(command){
                    case 'loginout':
                        this.$store.commit('loginout')
                        break;
                    case 'login':
                        this.$store.state.showloginform = true
                        break;
                    case 'register':
                            window.location.href=this.$store.state.baseurl+'user/register.html'
                        break;
                    case 'appindex':
                        this.$router.push({name:'Index',params:{}})
                        break;

                    case 'appuserhome':
                        this.$router.push({name:'User',params:{uid:this.$store.state.uid},query:{uid:this.$store.state.uid}})
                        break;
                }

            },
            golink(navtitle){
               var  _name='Index'
                switch (navtitle){
                    case 'plugin':
                            _name="Plugin"
                        break;
                    case 'template':
                        _name="Template"
                        break;
                    case 'extend':
                        _name="Extend"
                        break;
                    case 'index':
                        _name="Index"
                        break;
                    case 'chengxu':
                        _name="Chengxu"
                        break;
                    default:
                        break;
                }
                window.localStorage.setItem("navtitle",navtitle)
                this.$store.state.currenttype=navtitle
                this.getnav()
                this.$router.push({name:_name,params:{type:navtitle},query:{type:navtitle}})
            },
            uploadapp:function(){
                if(this.$store.state.loginstate){
                    this.$router.push({name:'AddApplication',params:{}})
                }else{

                    this.$store.state.showloginform = true
                }

            }
        }
        }

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue